import { getRuntimeInfo } from '@/hooks/useRuntimeInfo';
import * as selectors from '@/store/selectors';
import { useDebounceEffect } from 'ahooks';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export function initHubspotTracker(uid?: string, email?: string) {
  //@ts-ignore
  window?._hsp?.push(['identify', { id: uid, email: email }]);
}

export async function sendHubspotRegistrations(properties: {
  email: string;
  lastname: string;
  firstname: string;
}) {
  const data = JSON.stringify({
    objectWriteTraceId: 'string',
    properties: properties,
  });
  console.log(data);
  const header = {
    'Content-Type': 'application/json',
  };

  /**
   *  add aurthorization header in nginx httpproxy, change request to
   * 'https://api.hubapi.com/crm/v3/objects/contacts?idProperty=email';
   *
   */
  const customUrl = '/hubspot/crm/v3/objects/contacts';

  return await fetch(customUrl, {
    method: 'POST',
    headers: header,
    body: data,
  });
}

export const useHubspotPageViewTracker = () => {
  if (getRuntimeInfo().online !== true) return;
  const location = useLocation();
  const user = useSelector(selectors.user);

  useDebounceEffect(
    () => {
      // @ts-ignore
      if (!window?._hsp) {
        console.log('[hubspot]: window._hsp is undefined');
      }
      // @ts-ignore
      window?._hsp?.push?.([
        'identify',
        { email: user?.username, id: user?.uid },
      ]);
    },
    [location],
    { wait: 500 }
  );
};
